import { createTheme, lighten, darken } from '@mui/material/styles';
import { purple } from '@mui/material/colors';


const base = "#9778ce"; // ta teinte "light"

const theme = createTheme({
  palette: {
    primary: { light: "#7e57c2", main: base, dark: "#583c87" },
    secondary: {
      main: base,                       // <-- ce sera la couleur des boutons "secondary"
      light: lighten(base, 0.1),
      dark:  darken(base, 0.2),
      contrastText: '#fff',
    },
  },
  shape: { borderRadius: 14 },
  components: {
    MuiCard: { styleOverrides: { root: { borderRadius: 18 } } },
    MuiButton: { defaultProps: { variant: "contained" } }
  }
});

export default theme;
